import store from '@/store'
import axios from './Http.js'

export default {
    addLog(params) {
        // 用户Id
        params.userId = window.localStorage.getItem('id')
        // 用户名
        params.username = window.localStorage.getItem('username')

        axios.post(store.state.serverUrl + "operation/log/add", params).then(res=>{}).catch(err=>{})
    }
}
